import {BaseService} from "../../../global/classes";
import axios from "axios";
import config from "../../../config";

export default class FeesService extends BaseService {
  getFees = async () => {

    try {
      const response = await axios.get(`${config.apiBaseUrl}/billing-policy`,
        {
          params: {
            offset: 0,
            pageSize: 200,
            MerchantId: this.selectedCompany?.merchantId
          },
          headers: {
            Authorization: `Bearer ${this.legacyAccessToken?.token}`,
            "Content-Type": "application/json",
          }
        }
      )

      return response.data.response;
    } catch (error) {
      throw error;
    }
  }
}
